(() => {
  'use strict';

  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const config = window.theme || { routes: {}, strings: {} };
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

    const closeMenus = (except) => {
    $$('details[data-menu][open]').forEach((details) => {
      if (details !== except) details.open = false;
    });
  };

  document.addEventListener('click', (event) => {
    const closer = event.target.closest('[data-drawer-close]');
    if (closer) {
      const details = closer.closest('details');
      if (details) details.open = false;
      return;
    }
    closeMenus(event.target.closest('details[data-menu]'));
  });

  const resetDrawer = (drawer) => {
    $$('[data-drawer-sub]', drawer).forEach((panel) => panel.classList.remove('is-active'));
    $$('[data-drawer-open]', drawer).forEach((opener) => opener.setAttribute('aria-expanded', 'false'));
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      const drawer = opener.closest('.drawer');
      const target = document.getElementById(opener.dataset.drawerOpen);
      if (!drawer || !target) return;
      resetDrawer(drawer);
      target.classList.add('is-active');
      opener.setAttribute('aria-expanded', 'true');
      return;
    }
    const back = event.target.closest('[data-drawer-back]');
    if (back) {
      const drawer = back.closest('.drawer');
      const active = $('[data-drawer-open][aria-expanded="true"]', drawer);
      resetDrawer(drawer);
      if (active) active.focus();
    }
  });

  document.addEventListener('toggle', (event) => {
    const drawer = event.target;
    if (drawer.matches && drawer.matches('.drawer') && !drawer.open) resetDrawer(drawer);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = $$('details[data-menu][open]');
    if (!open.length) return;
    open.forEach((details) => { details.open = false; });
    const summary = $('summary', open[0]);
    if (summary) summary.focus();
  });

    let toastTimer;

  const showToast = (message, withCartLink) => {
    const toast = $('[data-toast]');
    if (!toast) return;
    toast.textContent = '';
    const text = document.createElement('span');
    text.textContent = message;
    toast.append(text);
    if (withCartLink) {
      const link = document.createElement('a');
      link.href = config.routes.cart;
      link.textContent = config.strings.viewCart;
      toast.append(link);
    }
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toast.hidden = true; }, 4500);
  };

  const updateCount = (count) => {
    $$('[data-cart-count]').forEach((element) => {
      element.textContent = count;
      element.hidden = count === 0;
    });
  };

  const drawerEl = () => $('[data-cart-drawer]');
  const drawerSectionId = () => {
    const el = drawerEl();
    return el ? el.dataset.sectionId : '';
  };

  const applyDrawer = (html) => {
    const el = drawerEl();
    if (!el) return;
    const fresh = $('[data-cart-drawer-content]', parse(html));
    const current = $('[data-cart-drawer-content]', el);
    if (!fresh || !current) return;
    current.replaceWith(fresh);
    updateCount(Number(fresh.dataset.count || 0));
    if (typeof hydrateBoost === 'function') hydrateBoost();
  };

  let closeTimer;

  const openDrawer = () => {
    const el = drawerEl();
    if (!el) return;
    clearTimeout(closeTimer);
    el.classList.add('is-active');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cart-open');
    requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('is-open')));
    const close = $('.cd__close', el);
    if (close) close.focus({ preventScroll: true });
  };

  const closeDrawer = () => {
    const el = drawerEl();
    if (!el || !el.classList.contains('is-active')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cart-open');
    closeTimer = setTimeout(() => el.classList.remove('is-active'), 220);
  };

  const cartRequest = async (url, payload) => {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...payload, sections: drawerSectionId() })
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || config.strings.error);
    return data;
  };

  const drawerAction = async (url, payload) => {
    const content = $('[data-cart-drawer-content]', drawerEl());
    if (content) content.setAttribute('aria-busy', 'true');
    try {
      const data = await cartRequest(url, payload);
      const html = data.sections && data.sections[drawerSectionId()];
      if (html) applyDrawer(html);
    } catch (err) {
      if (content) content.removeAttribute('aria-busy');
      showToast(err.message || config.strings.error, false);
    }
  };

  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-cart-open]');
    if (open && drawerEl() && config.cartAction !== 'redirect' && !document.querySelector('[data-cart-root]')) {
      event.preventDefault();
      openDrawer();
      return;
    }
    if (event.target.closest('[data-cart-drawer-close]')) {
      closeDrawer();
      return;
    }
    const step = event.target.closest('[data-cd-step]');
    if (step) {
      const quantity = Math.max(0, Number(step.dataset.quantity) + Number(step.dataset.cdStep));
      drawerAction(config.routes.cartChange, { line: Number(step.dataset.line), quantity });
      return;
    }
    const filtersOpen = event.target.closest('[data-filters-open]');
    if (filtersOpen) {
      const form = document.getElementById(filtersOpen.getAttribute('aria-controls'));
      const layout = form && form.closest('.collection__layout');
      if (layout) {
        layout.classList.add('is-filters-open');
        document.documentElement.classList.add('filters-open');
      }
      return;
    }
    if (event.target.closest('[data-filters-close]')) {
      closeFilters();
      return;
    }
    const cardAdd = event.target.closest('[data-card-add]');
    if (cardAdd) {
      const id = cardAdd.dataset.variant;
      if (!id) return;
      cardAdd.setAttribute('aria-busy', 'true');
      cartRequest(config.routes.cartAdd, { id: Number(id), quantity: 1 })
        .then((data) => {
          const html = data.sections && data.sections[drawerSectionId()];
          if (config.cartAction === 'redirect' || !drawerEl() || !html) {
            window.location.href = config.routes.cart;
            return;
          }
          applyDrawer(html);
          openDrawer();
        })
        .catch((err) => showToast(err.message || config.strings.error, false))
        .finally(() => cardAdd.removeAttribute('aria-busy'));
      return;
    }
    const quick = event.target.closest('[data-quick-add]');
    if (quick) {
      drawerAction(config.routes.cartAdd, { id: Number(quick.dataset.quickAdd), quantity: 1 });
    }
  });

  const boostState = { key: '', data: null };

  const fmtMoney = (value, format) => {
    const cents = Math.round(Number(value) * 100);
    const grouped = (n, thousands, decimal, digits) => {
      const fixed = (n / 100).toFixed(digits);
      const [int, dec] = fixed.split('.');
      const body = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return dec ? body + decimal + dec : body;
    };
    const fmt = format || '{{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, name) => {
      if (name === 'amount_no_decimals') return grouped(cents, ',', '.', 0);
      if (name === 'amount_with_comma_separator') return grouped(cents, '.', ',', 2);
      if (name === 'amount_no_decimals_with_comma_separator') return grouped(cents, '.', ',', 0);
      if (name === 'amount_no_decimals_with_space_separator') return grouped(cents, ' ', '.', 0);
      if (name === 'amount_with_space_separator') return grouped(cents, ' ', ',', 2);
      if (name === 'amount_with_apostrophe_separator') return grouped(cents, "'", '.', 2);
      return grouped(cents, ',', '.', 2);
    });
  };

  const escapeHtml = (value) => String(value == null ? '' : value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  const firstVariant = (item) => (item.variants || []).find((v) => v.stock !== 0) || (item.variants || [])[0] || null;

  const boostPrice = (variant, root) => {
    const fm = root.dataset.moneyFormat;
    const compare = variant.compareAt && variant.compareAt > variant.price ? '<s>' + escapeHtml(fmtMoney(variant.compareAt, fm)) + '</s> ' : '';
    return '<p class="cd-card__price">' + compare + '<strong>' + escapeHtml(fmtMoney(variant.price, fm)) + '</strong></p>';
  };

  const boostButton = (variant, root, label, featured, offer, placement) => {
    const cls = featured ? root.dataset.btnFeatured : root.dataset.btnDefault;
    const text = root.dataset.btnIcon === 'true' ? '+' : label;
    const disabled = variant && variant.stock === 0 ? ' disabled' : '';
    return '<button type="button" class="' + escapeHtml(cls) + '" data-boost-add="' + (variant ? variant.variant_id : '') + '" data-offer="' + escapeHtml(offer) + '" data-placement="' + placement + '" aria-label="' + escapeHtml(label) + '"' + disabled + '>' + escapeHtml(text) + '</button>';
  };

  const boostCard = (item, layout, root, label, placement) => {
    const variant = firstVariant(item);
    if (!variant) return '';
    const featured = layout === 'featured';
    const cls = 'cd-card cd-card--' + layout + (featured ? ' color-' + escapeHtml(root.dataset.scheme) : '');
    const badge = item.percent > 0 && root.dataset.badgeLabel ? '<span class="cd-card__badge">' + escapeHtml(root.dataset.badgeLabel) + ' ' + item.percent + '%</span>' : '';
    const sub = item.variants.length > 1 ? '' : (variant.variant && variant.variant !== 'Default Title' ? variant.variant : '');
    let picker = '';
    if (item.variants.length > 1) {
      picker = '<select class="cd-card__select" data-boost-variant aria-label="' + escapeHtml(item.name) + '">' + item.variants.map((v) => '<option value="' + v.variant_id + '"' + (v.variant_id === variant.variant_id ? ' selected' : '') + (v.stock === 0 ? ' disabled' : '') + ' data-price="' + v.price + '" data-compare="' + (v.compareAt || 0) + '">' + escapeHtml(v.variant) + '</option>').join('') + '</select>';
    }
    return '<article class="' + cls + '" data-boost-card>' +
      '<div class="cd-card__media">' + (variant.image ? '<img src="' + escapeHtml(variant.image) + '" alt="" loading="lazy">' : '') + '</div>' +
      '<div class="cd-card__body"><div class="cd-card__text"><h4 class="cd-card__title">' + escapeHtml(item.name) + '</h4>' +
      (sub ? '<p class="cd-card__sub">' + escapeHtml(sub) + '</p>' : '') + '</div>' + picker +
      '<div class="cd-card__meta">' + badge + '<span data-boost-price>' + boostPrice(variant, root) + '</span></div>' +
      boostButton(variant, root, label, featured, item.offer, placement) + '</div></article>';
  };

  const bundleHtml = (block, root) => {
    const items = (block.items || []).filter((item) => firstVariant(item));
    if (!items.length) return '';
    const label = block.button || root.dataset.bundleButton;
    const title = block.title || root.dataset.bundleHeading;
    const grid = items.slice(1).map((item) => boostCard(item, 'grid', root, label, 'drawer_bundle')).join('');
    return '<section class="cd__section cd__section--bundle" data-boost-section>' +
      (title ? '<h3 class="cd__heading">' + escapeHtml(title) + '</h3>' : '') +
      '<div class="cd__rail">' + boostCard(items[0], 'featured', root, label, 'drawer_bundle') + (grid ? '<div class="cd__grid">' + grid + '</div>' : '') + '</div></section>';
  };

  const recHtml = (block, root) => {
    const items = (block.items || []).filter((item) => firstVariant(item));
    if (!items.length) return '';
    const label = block.button || root.dataset.recButton;
    const title = block.title || root.dataset.recHeading;
    return '<section class="cd__section cd__section--rec" data-boost-section>' +
      (title ? '<h3 class="cd__heading">' + escapeHtml(title) + '</h3>' : '') +
      '<div class="cd__list cd__rail">' + items.map((item) => boostCard(item, 'row', root, label, 'drawer_rec')).join('') + '</div></section>';
  };

  const personalHtml = (block, line, root) => {
    const items = (block.items || []).filter((item) => firstVariant(item));
    if (!items.length) return '';
    const item = items[0];
    const variant = firstVariant(item);
    const labelTpl = root.dataset.personalLabel || '{product}';
    const label = labelTpl.replace('{product}', line.dataset.title || '');
    const button = block.button || root.dataset.saveButton;
    const picker = item.variants.length > 1
      ? '<select class="cd-personal__select" data-boost-variant aria-label="' + escapeHtml(item.name) + '">' + item.variants.map((v) => '<option value="' + v.variant_id + '"' + (v.variant_id === variant.variant_id ? ' selected' : '') + (v.stock === 0 ? ' disabled' : '') + ' data-price="' + v.price + '" data-compare="' + (v.compareAt || 0) + '">' + escapeHtml(v.variant) + '</option>').join('') + '</select>'
      : '';
    const badge = item.percent > 0 && root.dataset.badgeLabel ? '<span class="cd-card__badge">' + escapeHtml(root.dataset.badgeLabel) + ' ' + item.percent + '%</span>' : '';
    return '<div class="cd-personal" data-boost-card><p class="cd-personal__label">' + escapeHtml(label) + '</p>' +
      '<div class="cd-personal__row"><div class="cd-personal__media">' + (variant.image ? '<img src="' + escapeHtml(variant.image) + '" alt="" loading="lazy">' : '') + '</div>' +
      '<div class="cd-personal__text"><h4 class="cd-card__title">' + escapeHtml(item.name) + '</h4>' + picker +
      '<div class="cd-card__meta">' + badge + '<span data-boost-price>' + boostPrice(variant, root) + '</span></div></div>' +
      boostButton(variant, root, button, false, item.offer, 'drawer_item') + '</div></div>';
  };

  const paintBoost = (root, data) => {
    const aside = $('[data-cd-upsell]', root);
    if (aside) {
      const bundle = data.bundle ? bundleHtml(data.bundle, root) : '';
      const rec = data.rec ? recHtml(data.rec, root) : '';
      if (bundle || rec) {
        aside.innerHTML = bundle + rec;
        aside.hidden = false;
        root.classList.add('has-upsell');
      } else if (!aside.children.length) {
        aside.hidden = true;
        root.classList.remove('has-upsell');
      }
    }
    $$('[data-cd-line]', root).forEach((line) => {
      const slot = $('[data-cd-personal]', line);
      const block = data.personal && data.personal[line.dataset.variant];
      if (!slot || !block) return;
      const html = personalHtml(block, line, root);
      if (html) {
        slot.innerHTML = html;
        slot.hidden = false;
      }
    });
  };

  const sendBoostEvent = (type, button) => {
    const root = $('[data-boost-url]');
    if (!root) return;
    try {
      const body = JSON.stringify({ event: type, offer: Number(button.dataset.offer), variant_id: button.dataset.boostAdd, placement: button.dataset.placement });
      fetch(root.dataset.boostUrl.replace(/\/$/, '') + '/api/boost-event', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true }).catch(() => {});
    } catch (error) {}
  };

  const hydrateBoost = () => {
    const root = $('[data-boost-url]');
    if (!root) return;
    const lines = $$('[data-cd-line]', root).map((line) => ({ variant_id: Number(line.dataset.variant), quantity: Number(line.dataset.quantity) || 1 }));
    if (!lines.length) return;
    const key = JSON.stringify(lines);
    if (boostState.key === key && boostState.data) {
      paintBoost(root, boostState.data);
      return;
    }
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 6000);
    fetch(root.dataset.boostUrl.replace(/\/$/, '') + '/api/drawer-boost', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ lines }),
      signal: controller.signal
    })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (!data) return;
        boostState.key = key;
        boostState.data = data;
        const current = $('[data-boost-url]');
        if (current) paintBoost(current, data);
      })
      .catch(() => {})
      .finally(() => clearTimeout(timer));
  };

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-boost-variant]');
    if (!select) return;
    const card = select.closest('[data-boost-card]');
    const root = $('[data-boost-url]');
    if (!card || !root) return;
    const option = select.selectedOptions[0];
    const add = $('[data-boost-add]', card);
    if (add) add.dataset.boostAdd = select.value;
    const price = $('[data-boost-price]', card);
    if (price && option) price.innerHTML = boostPrice({ price: Number(option.dataset.price), compareAt: Number(option.dataset.compare) }, root);
  });

  document.addEventListener('click', (event) => {
    const add = event.target.closest('[data-boost-add]');
    if (!add || add.disabled) return;
    const id = Number(add.dataset.boostAdd);
    if (!id) return;
    sendBoostEvent('add', add);
    drawerAction(config.routes.cartAdd, { id, quantity: 1 });
  });

  const closeFilters = () => {
    $$('.collection__layout.is-filters-open').forEach((el) => el.classList.remove('is-filters-open'));
    document.documentElement.classList.remove('filters-open');
  };

  window.addEventListener('resize', () => { if (window.innerWidth >= 990) closeFilters(); });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeDrawer();
      closeFilters();
    }
  });

  document.addEventListener('shopify:section:select', (event) => {
    if (event.target.querySelector && event.target.querySelector('[data-cart-drawer]')) openDrawer();
  });
  document.addEventListener('shopify:section:deselect', (event) => {
    if (event.target.querySelector && event.target.querySelector('[data-cart-drawer]')) closeDrawer();
  });

    document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-product-form]');
    if (!form) return;
    event.preventDefault();

    const button = $('[data-add-to-cart]', form);
    const error = $('[data-form-error]', form.parentElement);
    if (button && button.disabled) return;

    if (error) error.hidden = true;
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    try {
      const useDrawer = config.cartAction !== 'redirect' && drawerEl();
      const body = new FormData(form);
      if (useDrawer) body.append('sections', drawerSectionId());
      const response = await fetch(config.routes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || config.strings.error);

      if (config.cartAction === 'redirect') {
        window.location.href = config.routes.cart;
        return;
      }

      if (useDrawer) {
        let html = data.sections && data.sections[drawerSectionId()];
        if (!html) {
          const res = await fetch(window.location.pathname + '?sections=' + drawerSectionId());
          const json = await res.json();
          html = json[drawerSectionId()];
        }
        if (html) {
          applyDrawer(html);
          openDrawer();
          return;
        }
      }

      const cart = await (await fetch(config.routes.cart + '.js')).json();
      updateCount(cart.item_count);
      showToast(config.strings.added, true);
    } catch (err) {
      if (error) {
        error.textContent = err.message || config.strings.error;
        error.hidden = false;
      }
    } finally {
      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }
  });

    let variantRequest;

  document.addEventListener('change', async (event) => {
    const picker = event.target.closest('[data-variant-picker]');
    if (!picker) return;

    const root = picker.closest('[data-product-root]');
    if (!root) return;

    const ids = $$('input[type="radio"]:checked, select', picker).map((element) => (
      element.tagName === 'SELECT'
        ? element.selectedOptions[0].dataset.optionValueId
        : element.dataset.optionValueId
    ));

    if (variantRequest) variantRequest.abort();
    variantRequest = new AbortController();

    const url = `${picker.dataset.productUrl}?option_values=${ids.join(',')}&section_id=${root.dataset.sectionId}`;
    const activeId = document.activeElement && document.activeElement.id;

    try {
      const response = await fetch(url, { signal: variantRequest.signal });
      if (!response.ok) return;
      const doc = parse(await response.text());

      $$('[data-product-update]', root).forEach((current) => {
        const fresh = $(`[data-product-update="${current.dataset.productUpdate}"]`, doc);
        if (fresh) current.replaceWith(fresh);
      });

      const meta = $('[data-product-update="variant"]', root);
      if (meta && meta.dataset.variantId) {
        history.replaceState({}, '', `${location.pathname}?variant=${meta.dataset.variantId}`);
        if (meta.dataset.mediaId) scrollToMedia(root, meta.dataset.mediaId, true);
      }

      if (activeId) {
        const again = document.getElementById(activeId);
        if (again) again.focus();
      }

      if (window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
    } catch (err) {
      if (err.name !== 'AbortError') console.error(err);
    }
  });

    const scrollToMedia = (root, mediaId, smooth) => {
    const track = $('[data-gallery-track]', root);
    const slide = track && $(`[data-media-id="${mediaId}"]`, track);
    if (!track || !slide || track.scrollWidth <= track.clientWidth) return;
    const gallery = track.closest('[data-gallery]');
    const widthPercent = parseFloat(getComputedStyle(gallery).getPropertyValue('--slide-w')) || 100;
    const peek = track.clientWidth * (1 - widthPercent / 100);
    track.scrollTo({ left: slide.offsetLeft - track.offsetLeft - peek, behavior: smooth ? 'smooth' : 'auto' });
  };

  const markThumb = (gallery, mediaId) => {
    $$('[data-thumb]', gallery).forEach((thumb) => {
      thumb.setAttribute('aria-current', String(thumb.dataset.thumb === mediaId));
    });
  };

  const galleryState = new WeakMap();
  const videoMarks = new WeakMap();

  const pushData = (payload) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  };

  const stateOf = (gallery) => {
    let state = galleryState.get(gallery);
    if (!state) {
      state = { index: null, max: 0, interacted: false, navMethod: '', navTarget: '', navAt: 0, touchMethod: 'swipe', touchAt: 0, sentMax: -1 };
      galleryState.set(gallery, state);
    }
    return state;
  };

  const markNav = (gallery, method, target) => {
    const state = stateOf(gallery);
    state.navMethod = method;
    state.navTarget = target || '';
    state.navAt = Date.now();
  };

  const markTouch = (gallery, method) => {
    const state = stateOf(gallery);
    state.touchMethod = method;
    state.touchAt = Date.now();
  };

  const mediaTypeOf = (slide) => {
    const node = slide && slide.querySelector('video, iframe, model-viewer');
    if (!node) return 'image';
    if (node.tagName === 'VIDEO') return 'video';
    if (node.tagName === 'IFRAME') return 'external_video';
    return 'model';
  };

  const trackIndex = (gallery, slides, index) => {
    const state = stateOf(gallery);
    const previous = state.index;
    const now = Date.now();
    const fromNav = now - state.navAt < 1500;
    const fromTouch = now - state.touchAt < 2000;
    const byNav = fromNav && state.navAt >= state.touchAt;
    if (previous !== null && byNav && state.navTarget && slides[index].dataset.mediaId !== state.navTarget) return;
    state.index = index;
    state.max = Math.max(state.max, index);
    if (previous === null || previous === index) return;
    if (!fromNav && !fromTouch) return;
    state.interacted = true;
    pushData({
      event: 'gallery_navigate',
      gallery_index: index + 1,
      gallery_total: slides.length,
      gallery_method: byNav ? state.navMethod : state.touchMethod,
      gallery_direction: index > previous ? 'next' : 'prev',
      gallery_media_type: mediaTypeOf(slides[index]),
      gallery_interacted: true
    });
  };

  const sendGalleryDepth = () => {
    $$('[data-gallery]').forEach((gallery) => {
      const state = stateOf(gallery);
      const total = $$('[data-gallery-track] [data-media-id]', gallery).length;
      if (total < 2 || state.sentMax === state.max) return;
      state.sentMax = state.max;
      pushData({
        event: 'gallery_depth',
        gallery_max_index: state.max + 1,
        gallery_total: total,
        gallery_interacted: state.interacted
      });
    });
  };

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') sendGalleryDepth();
  });
  window.addEventListener('pagehide', sendGalleryDepth);

  const videoContext = (video) => {
    if (!video || video.tagName !== 'VIDEO') return null;
    const slide = video.closest('.gallery__slide');
    const gallery = slide && slide.closest('[data-gallery]');
    if (!gallery) return null;
    const slides = $$('[data-gallery-track] [data-media-id]', gallery);
    return { gallery, index: slides.indexOf(slide) + 1, total: slides.length };
  };

  const videoMarksOf = (video) => {
    let marks = videoMarks.get(video);
    if (!marks) {
      marks = { played: false, steps: {} };
      videoMarks.set(video, marks);
    }
    return marks;
  };

  const pushVideoProgress = (video, context, percent) => {
    const marks = videoMarksOf(video);
    if (marks.steps[percent]) return;
    marks.steps[percent] = true;
    pushData({
      event: 'gallery_video_progress',
      gallery_index: context.index,
      gallery_total: context.total,
      gallery_video_percent: percent,
      gallery_interacted: true
    });
  };

  document.addEventListener('play', (event) => {
    const context = videoContext(event.target);
    if (!context) return;
    const marks = videoMarksOf(event.target);
    if (marks.played) return;
    marks.played = true;
    stateOf(context.gallery).interacted = true;
    pushData({
      event: 'gallery_video_play',
      gallery_index: context.index,
      gallery_total: context.total,
      gallery_interacted: true
    });
  }, true);

  document.addEventListener('timeupdate', (event) => {
    const video = event.target;
    const context = videoContext(video);
    if (!context || !video.duration) return;
    const percent = (video.currentTime / video.duration) * 100;
    [25, 50, 75].forEach((step) => {
      if (percent >= step) pushVideoProgress(video, context, step);
    });
  }, true);

  document.addEventListener('ended', (event) => {
    const context = videoContext(event.target);
    if (context) pushVideoProgress(event.target, context, 100);
  }, true);

  const initGallery = (gallery) => {
    const track = $('[data-gallery-track]', gallery);
    if (!track || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        markThumb(gallery, entry.target.dataset.mediaId);
        const slides = $$('[data-media-id]', track);
        const index = slides.indexOf(entry.target);
        gallery.dataset.index = String(index);
        trackIndex(gallery, slides, index);
        slides.forEach((slide) => { slide.dataset.current = String(slide === entry.target); });
        const counter = $('[data-gallery-counter]', gallery);
        if (counter) counter.textContent = `${index + 1} / ${slides.length}`;
      });
    }, { root: track, threshold: 0.6 });

    $$('[data-media-id]', track).forEach((slide) => observer.observe(slide));

    ['pointerdown', 'touchstart', 'wheel'].forEach((name) => {
      track.addEventListener(name, () => markTouch(gallery, 'swipe'), { passive: true });
    });
    track.addEventListener('keydown', () => markTouch(gallery, 'keyboard'));

    const root = gallery.closest('[data-product-root]');
    const meta = root && $('[data-product-update="variant"]', root);
    if (meta && meta.dataset.mediaId) scrollToMedia(root, meta.dataset.mediaId, false);
  };

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-gallery]');
    if (gallery) markNav(gallery, thumb.classList.contains('gallery__dot') ? 'dot' : 'thumbnail', thumb.dataset.thumb);
    scrollToMedia(gallery, thumb.dataset.thumb, true);
  });

  document.addEventListener('click', (event) => {
    const step = event.target.closest('[data-gallery-step]');
    if (!step) return;
    const gallery = step.closest('[data-gallery]');
    const slides = $$('[data-gallery-track] [data-media-id]', gallery);
    if (!slides.length) return;
    const next = Math.min(slides.length - 1, Math.max(0, (Number(gallery.dataset.index) || 0) + Number(step.dataset.galleryStep)));
    markNav(gallery, 'arrow', slides[next].dataset.mediaId);
    scrollToMedia(gallery, slides[next].dataset.mediaId, true);
  });

  document.addEventListener('click', (event) => {
    const slide = event.target.closest('.gallery__slide[data-media-id]');
    if (!slide) return;
    const gallery = slide.closest('[data-gallery]');
    const slides = $$('[data-gallery-track] [data-media-id]', gallery);
    if (slides.indexOf(slide) === (Number(gallery.dataset.index) || 0)) return;
    markNav(gallery, 'click', slide.dataset.mediaId);
    scrollToMedia(gallery, slide.dataset.mediaId, true);
  });


  const initSlideshow = (root) => {
    if (root.dataset.ssReady) return;
    root.dataset.ssReady = '1';

    const track = $('[data-ss-track]', root);
    const slides = $$('[data-ss-slide]', root);
    const dots = $$('[data-ss-go]', root);
    const pauseBtn = $('[data-ss-pause]', root);
    const cursor = $('[data-ss-cursor]', root);
    const loop = root.dataset.loop !== 'false';
    const auto = root.dataset.autoplay === 'true' && slides.length > 1;
    const editor = Boolean(window.Shopify && window.Shopify.designMode);
    let index = 0;
    let userPaused = false;

    const setPaused = (value) => {
      root.classList.toggle('is-paused', value);
    };

    const render = () => {
      if (!root.classList.contains('ss--fade')) track.style.transform = 'translate3d(' + (-index * 100) + '%,0,0)';
      slides.forEach((slide, n) => {
        const active = n === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) slide.removeAttribute('inert');
        else slide.setAttribute('inert', '');
        const video = slide.querySelector('video');
        if (video) {
          if (active) video.play().catch(() => {});
          else video.pause();
        }
      });
      dots.forEach((dot, n) => {
        dot.classList.toggle('is-active', n === index);
        dot.setAttribute('aria-selected', n === index ? 'true' : 'false');
      });
    };

    const go = (target) => {
      if (slides.length < 2) return;
      let next = target;
      if (next < 0) next = loop ? slides.length - 1 : 0;
      if (next > slides.length - 1) next = loop ? 0 : slides.length - 1;
      if (next === index) return;
      index = next;
      render();
    };

    const next = () => go(index + 1);
    const prev = () => go(index - 1);

    root.addEventListener('click', (event) => {
      if (event.target.closest('[data-ss-next]')) next();
      else if (event.target.closest('[data-ss-prev]')) prev();
      const dot = event.target.closest('[data-ss-go]');
      if (dot) go(Number(dot.dataset.ssGo));
    });

    if (pauseBtn) {
      pauseBtn.addEventListener('click', () => {
        userPaused = !userPaused;
        pauseBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', userPaused ? 'Play autoplay' : 'Pause autoplay');
        setPaused(userPaused);
      });
    }

    if (auto) {
      root.addEventListener('animationend', (event) => {
        if (!event.target.classList.contains('ss__fill')) return;
        if (!loop && index === slides.length - 1) return;
        next();
      });
      document.addEventListener('visibilitychange', () => {
        setPaused(userPaused || document.hidden);
      });
      if (editor) {
        userPaused = true;
        setPaused(true);
      }
    }

    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') next();
      if (event.key === 'ArrowLeft') prev();
    });

    let startX = 0;
    let startY = 0;
    root.addEventListener('touchstart', (event) => {
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });
    root.addEventListener('touchend', (event) => {
      const dx = event.changedTouches[0].clientX - startX;
      const dy = event.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) next();
        else prev();
      }
    }, { passive: true });

    if (cursor && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      let frame = 0;
      let x = 0;
      let y = 0;
      const place = () => {
        frame = 0;
        cursor.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
      };
      root.addEventListener('mousemove', (event) => {
        const rect = root.getBoundingClientRect();
        x = event.clientX;
        y = event.clientY;
        cursor.classList.toggle('is-left', event.clientX < rect.left + rect.width / 2);
        const overUi = event.target.closest('.ss__nav, .btn, .ss__buttons a');
        cursor.classList.toggle('is-visible', !overUi);
        if (!frame) frame = requestAnimationFrame(place);
      });
      root.addEventListener('mouseleave', () => cursor.classList.remove('is-visible'));
    }

    root.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest('[data-ss-slide]') || event.target.querySelector('[data-ss-slide]');
      const n = slides.indexOf(slide);
      if (n > -1) {
        const prevDur = track.style.transitionDuration;
        index = n;
        render();
        track.style.transitionDuration = prevDur;
      }
    });

    render();
  };

  const initSubtabs = (root) => {
    const list = $('[data-subtabs-list]', root);
    const active = list && $('.is-active', list);
    if (!active || list.scrollWidth <= list.clientWidth) return;
    list.scrollLeft = active.parentElement.offsetLeft - (list.clientWidth - active.offsetWidth) / 2;
  };

  let syncingTabs = false;
  const syncTabsFilters = () => {
    if (syncingTabs) return;
    syncingTabs = true;
    $$('.collection__layout').forEach((layout) => {
      const bar = $('.subtabs--align', layout);
      const summary = $('.filters details:first-of-type summary', layout);
      layout.style.removeProperty('--filters-first-h');
      layout.style.removeProperty('--filters-top');
      if (bar) bar.style.minHeight = '';
      if (!bar || !summary || window.innerWidth < 990) return;
      const barStyle = getComputedStyle(bar);
      if (barStyle.position === 'sticky' && parseFloat(barStyle.top) >= 0) layout.style.setProperty('--filters-top', parseFloat(barStyle.top) + 'px');
      const barHeight = Math.ceil(bar.getBoundingClientRect().height);
      const rowHeight = Math.ceil(summary.getBoundingClientRect().height);
      const total = Math.max(barHeight, rowHeight + 2);
      bar.style.minHeight = total + 'px';
      layout.style.setProperty('--filters-first-h', (total - 2) + 'px');
      if ('ResizeObserver' in window && !bar.dataset.alignObserved) {
        bar.dataset.alignObserved = '1';
        new ResizeObserver(() => requestAnimationFrame(syncTabsFilters)).observe(bar);
      }
    });
    syncingTabs = false;
  };

  const initScrollNav = (track) => {
    if (track.dataset.scrollnav || track.hasAttribute('data-no-scrollnav')) return;
    track.dataset.scrollnav = '1';
    const tpl = document.getElementById('scrollnav-icons');
    const icon = (key) => (tpl ? (tpl.content.querySelector('[data-icon="' + key + '"]') || {}).innerHTML || '' : '');
    const nav = document.createElement('div');
    nav.className = 'scrollnav';
    nav.hidden = true;
    nav.innerHTML = '<button type="button" class="scrollnav__btn" aria-label="' + (config.strings.sliderPrev || 'Previous') + '">' + icon('prev') + '</button><div class="scrollnav__bar"><span class="scrollnav__thumb"></span></div><button type="button" class="scrollnav__btn" aria-label="' + (config.strings.sliderNext || 'Next') + '">' + icon('next') + '</button>';
    track.insertAdjacentElement('afterend', nav);
    const [prev, next] = $$('.scrollnav__btn', nav);
    const bar = $('.scrollnav__bar', nav);
    const thumb = $('.scrollnav__thumb', nav);
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      nav.hidden = max <= 2;
      if (nav.hidden) return;
      const ratio = track.clientWidth / track.scrollWidth;
      thumb.style.width = ratio * 100 + '%';
      thumb.style.left = (track.scrollLeft / max) * (1 - ratio) * 100 + '%';
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    };
    const step = () => {
      let item = track.firstElementChild;
      while (item && item.getBoundingClientRect().width === 0 && item.firstElementChild) item = item.firstElementChild;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return item ? item.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    };
    prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    const seek = (event) => {
      const rect = bar.getBoundingClientRect();
      const max = track.scrollWidth - track.clientWidth;
      const ratio = track.clientWidth / track.scrollWidth;
      const thumbW = rect.width * ratio;
      const x = Math.min(Math.max(event.clientX - rect.left - thumbW / 2, 0), rect.width - thumbW);
      track.scrollLeft = (x / (rect.width - thumbW || 1)) * max;
    };
    let dragging = false;
    bar.addEventListener('pointerdown', (event) => {
      dragging = true;
      track.style.scrollSnapType = 'none';
      bar.setPointerCapture(event.pointerId);
      seek(event);
    });
    bar.addEventListener('pointermove', (event) => { if (dragging) seek(event); });
    const stop = () => {
      if (!dragging) return;
      dragging = false;
      track.style.scrollSnapType = '';
    };
    bar.addEventListener('pointerup', stop);
    bar.addEventListener('pointercancel', stop);
    track.addEventListener('scroll', update, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    window.addEventListener('load', update);
    update();
  };

  const initAll = (scope) => {
    $$('.grid--scroll, .tiles--scroll, [data-scroller]', scope).forEach(initScrollNav);
    $$('[data-gallery]', scope).forEach(initGallery);
    $$('[data-slideshow]', scope).forEach(initSlideshow);
    $$('[data-subtabs]', scope).forEach(initSubtabs);
    syncTabsFilters();
  };

  const observeOnce = (element, callback) => {
    if (!element || !('ResizeObserver' in window) || element.dataset.hObserved) return;
    element.dataset.hObserved = '1';
    new ResizeObserver(callback).observe(element);
  };

  const syncHeaderOffset = () => {
    const header = document.querySelector('header');
    const wrapper = header && (header.closest('.shopify-section') || header);
    const sticky = wrapper && getComputedStyle(wrapper).position === 'sticky';
    const height = sticky ? Math.round(wrapper.getBoundingClientRect().height) : 0;
    const root = document.documentElement.style;
    root.setProperty('--header-h', height + 'px');
    let stack = height;
    const tabs = document.querySelector('[data-sticky-tabs]');
    const tabsWrap = tabs && tabs.closest('.shopify-section');
    if (tabsWrap && getComputedStyle(tabsWrap).position === 'sticky') {
      const top = parseFloat(getComputedStyle(tabsWrap).top) || height;
      stack = Math.round(top + tabsWrap.getBoundingClientRect().height);
      observeOnce(tabsWrap, syncHeaderOffset);
    }
    root.setProperty('--stack-h', stack + 'px');
    observeOnce(wrapper, syncHeaderOffset);
    syncTabsFilters();
  };

  document.addEventListener('DOMContentLoaded', () => { initAll(document); syncHeaderOffset(); hydrateBoost(); });
  window.addEventListener('resize', syncHeaderOffset);
  window.addEventListener('resize', syncTabsFilters);
  document.addEventListener('shopify:section:load', syncHeaderOffset);
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));

    document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-qty-step]');
    if (!button) return;
    const input = $('input', button.closest('[data-qty]'));
    if (!input) return;
    const min = Number(input.min) || 0;
    const next = Math.max(min, (Number(input.value) || 0) + Number(button.dataset.qtyStep));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

    const updateLine = async (line, quantity) => {
    const root = $('[data-cart-root]');
    if (!root) return;
    root.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(config.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || config.strings.error);

      updateCount(cart.item_count);
      const doc = parse(await (await fetch(window.location.href)).text());
      const fresh = $('[data-cart-root]', doc);
      if (fresh) root.replaceWith(fresh);
    } catch (err) {
      root.removeAttribute('aria-busy');
      showToast(err.message || config.strings.error, false);
    }
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-cart-quantity]');
    if (input) updateLine(input.dataset.line, Number(input.value));
  });

  document.addEventListener('click', (event) => {
    const remove = event.target.closest('[data-cart-remove]');
    if (!remove) return;
    event.preventDefault();
    updateLine(remove.dataset.line, 0);
  });

    document.addEventListener('change', (event) => {
    const form = event.target.form;
    if (form && form.matches('[data-auto-submit]')) form.requestSubmit();
  });

  const checkoutBase = (() => {
    try {
      const url = new URL(String(config.checkoutUrl || '').trim());
      return url.protocol === 'https:' ? url : null;
    } catch (error) {
      return null;
    }
  })();

  const cookiesReachCheckout = (() => {
    if (!checkoutBase) return false;
    const own = window.location.hostname.toLowerCase().replace(/^www\./, '').split('.');
    const other = checkoutBase.hostname.toLowerCase().replace(/^www\./, '').split('.');
    let i = own.length - 1;
    let j = other.length - 1;
    let shared = 0;
    while (i >= 0 && j >= 0 && own[i] === other[j]) {
      shared += 1;
      i -= 1;
      j -= 1;
    }
    return shared >= 2;
  })();

  document.addEventListener('submit', async (event) => {
    const submitter = event.submitter;
    if (!checkoutBase || !submitter || submitter.name !== 'checkout') return;
    event.preventDefault();
    if (submitter.disabled) return;
    submitter.disabled = true;
    try {
      const cart = await (await fetch(config.routes.cart + '.js')).json();
      if (!cart.items || !cart.items.length) throw new Error('empty');
      const params = new URLSearchParams();
      params.set('items', cart.items.map((item) => item.variant_id + ':' + item.quantity).join(','));
      if (cart.token) params.set('ct', cart.token);
      params.set('o', window.location.origin);
      ['_fbp', '_fbc'].forEach((name) => {
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        if (match && match[1]) params.set(name.slice(1), decodeURIComponent(match[1]));
      });
      if (!cookiesReachCheckout) {
        [['sc_first', 'sf'], ['sc_last', 'sl'], ['sc_hist', 'sh'], ['sc_gads', 'sg']].forEach(([name, key]) => {
          const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
          if (match && match[1]) params.set(key, decodeURIComponent(match[1]));
        });
      }
      const shopify = window.Shopify || {};
      if (shopify.theme && shopify.theme.id && shopify.theme.role !== 'main') {
        params.set('t', String(shopify.theme.id));
      }
      window.location.href = checkoutBase.origin + '/checkout?' + params.toString();
    } catch (error) {
      submitter.disabled = false;
    }
  });

  (() => {
    const query = new URLSearchParams(window.location.search);
    if (!checkoutBase || query.get('cc') !== '1') return;
    let target = null;
    try {
      const url = new URL(query.get('return') || '');
      if (url.origin === checkoutBase.origin) target = url.href;
    } catch (error) {
      target = null;
    }
    const finish = () => {
      if (target) {
        window.location.replace(target);
        return;
      }
      updateCount(0);
      window.history.replaceState(null, '', window.location.pathname);
    };
    fetch(config.routes.cartClear, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: '{}'
    }).catch(() => {}).then(finish);
  })();
})();
